function itemsShowmore() {
  document.addEventListener("click", (event) => {
    const showmoreButton = event.target.closest(".js-items-showmore-button");
    if (showmoreButton) {
      const showmoreList = showmoreButton.closest(".js-items-showmore");
      if (showmoreList) {
        showmoreList.querySelectorAll(".js-items-showmore-target").forEach((element) => {
          element.style.removeProperty("display");
        });
        showmoreButton.style.display = "none";
      }
    }
  });
}

export { itemsShowmore };
